import * as React from "react";
import { TreeNode } from "./TreeNode";
import { ITreeViewProps } from "./SubNavigation.types";
export class TreeView extends React.Component<ITreeViewProps> {
  constructor(props: ITreeViewProps) {
    super(props);
  }
  render(): JSX.Element {
    var children = [];
    var rootName = "";

    if (this.props.Node.Children) {
      var that = this;
      this.props.Node.Children.forEach(function (node) {
        children.push(
          <TreeNode
            Node={node}
            key={node.Id}
            Level={node.PageTreeDepth}
            Language={that.props.Language}
            Visible={true}
            CurrentPageId={that.props.CurrentPageId}
            IsMobileMenu={false}
          />
        );
      });
    }

    var header = (
      <div className="sub-navigation__root sub-navigation__item sub-navigation__item-wrapper">
        {this.props.Node.Name}
      </div>
    );

    if (this.props.CurrentPageId !== this.props.Node.Id) {
      header = (
        <div className="sub-navigation__root sub-navigation__item sub-navigation__item-wrapper">
          <a className={"sub-navigation__link"} href={this.props.Node.Url}>
            {this.props.Node.Name}
          </a>
        </div>
      );
    }

    return (
      <nav
        id="sub-navigation"
        className="sub-navigation"
        aria-label={
          this.props.Language == "en"
            ? `Secondary navigation, contains all subpages to the page: ${this.props.Node.Name}`
            : `Sekundärnavigering, innehåller alla undersidor till sidan: ${this.props.Node.Name}`
        }
      >
        {/* {header} */}
        <ul className={"sub-navigation__menu"}>{children}</ul>
      </nav>
    );
  }
}
